<template>
  <b-container class="contentcontainer">
    <b-row class="contentcontainer__head">
      <b-col>
        <h2>{{$t('user.destroyheading')}}</h2>
      </b-col>
    </b-row>
    <hr/>
    <b-row>
      <b-col>
        <div v-if="!adminRequest" v-html="$t('user.userdestroyresults')">
        </div>

        <div>
          {{$t('user.destroywarning')}}
        </div>
        <table class="table table--overview">
          <tr>
            <td><strong>{{user.data.firstname}} {{user.data.lastname}} ({{user.data.email}})</strong></td>
          </tr>
        </table>
        <button v-on:click="localRemove" class="btn btn--danger">
          {{$t('user.confirmdestroy')}}
        </button>
      </b-col>
    </b-row>
    <b-row class="contentcontainer__footer" align-h="end">
      <b-col cols="auto">
        <div v-if="adminRequest">
          <a class="btn btn--link" href="#" v-on:click="localCancel">
            {{$t('user.stopdestroyadmin')}}
          </a>
        </div>
      </b-col>
      <b-col cols="auto">
        <div v-if="!adminRequest">
          <a class="btn btn--link" href="#" v-on:click="localCancel">
            {{$t('user.stopdestroyuser')}}
          </a>
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>

import { mapActions, mapMutations } from 'vuex'

export default {

  data () {
    return {
      user: {
        data: {}
      },
      adminRequest: false
    }
  },

  methods: {

    ...mapActions('user', [
      'getUserById',
      'removeUser'
    ]),

    ...mapMutations('common', [
      'endLoading'
    ]),

    preparePage (data) {
      this.user = data
    },

    localRemove () {
      this.removeUser(this.user.data.id)
      this.forward()
    },

    localCancel () {
      this.forward()
    },

    forward () {
      if (this.adminRequest) {
        this.$router.replace({
          path: '/userlist'
        })
      } else {
        this.$router.replace({
          path: '/sites'
        })
      }
    }
  },

  created () {
    this.axios.get('/api/user').then(
      response => {
        this.adminRequest = response.data.data.role === 99

        this.getUserById(this.$route.params.id).then(
          response => {
            this.preparePage(response)
            this.endLoading()
          }
        )
      }
    )
  }
}
</script>
